export default "__VITE_ASSET__Cda$e8n5__"